import { Directive, ElementRef, HostListener, OnInit, OnChanges, SimpleChanges, Input, Renderer2 } from '@angular/core';

/**
 * Directive info bulle
 * @implements OnInit, OnChanges
 */
@Directive({
  selector: '[appInfoBulle]'
})
export class InfoBulleDirective implements OnInit, OnChanges {
    @Input('appInfoBulle') texteInfoBulle: string;
    private infoBulleElement: HTMLElement = null;
    private estInitialise: boolean = false;

    /**
     * Constructeur
     * @param el
     * @param renderer
     */
    constructor(private el: ElementRef, private renderer: Renderer2) {
    }

    /**
     * Ev�nement mouseenter
     */
    @HostListener('mouseenter') onMouseEnter() {
        this.afficherInfoBulle(true);
    }

    /**
     * Ev�nement mouseleave
     */
    @HostListener('mouseleave') onMouseLeave() {
        this.afficherInfoBulle(false);
    }

    /**
     * Ev�nement click
     */
    @HostListener('click') onClick() {
        this.basculerInfoBulle();
    }

    /**
     * Initialisation du composant
     */
    ngOnInit() {
        if (this.texteInfoBulle) {
            this.creerInfoBulle(this.texteInfoBulle);
        }
        this.estInitialise = true;
    }

    /**
     * Changements
     */
    ngOnChanges(changes: SimpleChanges) {
        if (this.estInitialise && changes && changes.texteInfoBulle && this.texteInfoBulle) {
            this.modifierInfoBulle(this.texteInfoBulle);
        }
    }

    /**
     * Cr�er l'info bulle
     * @param texte
     */
    private creerInfoBulle(texte: string) {
        this.infoBulleElement = document.createElement("span");
        this.infoBulleElement.className = "info-text";
        this.infoBulleElement.innerText = texte;
        this.infoBulleElement.hidden = true;
        this.renderer.appendChild(this.el.nativeElement, this.infoBulleElement);
    }

    /**
     * Modifier l'info bulle
     * @param texte
     */
    private modifierInfoBulle(texte: string) {
        if (this.infoBulleElement == null) {
            this.creerInfoBulle(texte);
        }
        else {
            this.infoBulleElement.innerText = texte;
        }
    }

    /**
     * Afficher/Cacher l'info bulle
     * @param afficher
     */
    private afficherInfoBulle(afficher: boolean) {
        this.infoBulleElement.hidden = !afficher;
    }

   /**
    * Basculer l'info bulle
    * @param afficher
    */
    private basculerInfoBulle() {
        this.infoBulleElement.hidden = !this.infoBulleElement.hidden;
    }
}
